<!--================================
=            TYPOGRAPHY            =
=================================-->
<template>
  <!-- TYPOGRAPHY -->
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Typography</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Display Headings
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <h1 class="display-1">Display 1</h1>
              <h1 class="display-2">Display 2</h1>
              <h1 class="display-3">Display 3</h1>
              <h1 class="display-4">Display 4</h1>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- TYPOGRAPHY -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Headings
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <h6 class="card-subtitle">
                All HTML headings,
                <code class="highlighter-rouge">&lt;h1&gt;</code> through
                <code class="highlighter-rouge">&lt;h6&gt;</code>, are
                available.
              </h6>
              <h1>h1. Bootstrap heading</h1>
              <h2>h2. Bootstrap heading</h2>
              <h3>h3. Bootstrap heading</h3>
              <h4>h4. Bootstrap heading</h4>
              <h5>h5. Bootstrap heading</h5>
              <h6>h6. Bootstrap heading</h6>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- TYPOGRAPHY -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Inline text elements
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <h6 class="card-subtitle">Styling for common inline HTML5 elements.</h6>
              <p>
                You can use the mark tag to
                <mark>highlight</mark> text.
              </p>
              <p>
                <del>
                  This line of text is meant to be treated as deleted
                  text.
                </del>
              </p>
              <p>
                <s>
                  This line of text is meant to be treated as no longer
                  accurate.
                </s>
              </p>
              <p>
                <ins>
                  This line of text is meant to be treated as an addition to
                  the document.
                </ins>
              </p>
              <p>
                <u>This line of text will render as underlined</u>
              </p>
              <p>
                <small>
                  This line of text is meant to be treated as fine
                  print.
                </small>
              </p>
              <p>
                <strong>This line rendered as bold text.</strong>
              </p>
              <p>
                <em>This line rendered as italicized text.</em>
              </p>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- TYPOGRAPHY -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Blockquotes
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <h6 class="card-subtitle">
                For quoting blocks of content from another source within your
                document. Wrap
                <code
                  class="highlighter-rouge"
                >&lt;blockquote class="blockquote"&gt;</code>
                around any
                <abbr title="HyperText Markup Language">HTML</abbr> as the
                quote.
              </h6>
              <blockquote class="blockquote">
                <p class="mb-0">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Integer posuere erat a ante.
                </p>
              </blockquote>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- TYPOGRAPHY -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Naming a source
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <h6 class="card-subtitle">
                Add a
                <code class="highlighter-rouge">&lt;footer class="blockquote-footer"&gt;</code>
                for identifying the source. Wrap the name of the source work in
                <code
                  class="highlighter-rouge"
                >&lt;cite&gt;</code>.
              </h6>
              <blockquote class="blockquote">
                <p class="mb-0">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Integer posuere erat a ante.
                </p>
                <footer class="blockquote-footer">
                  Someone famous in
                  <cite title="Source Title">Source Title</cite>
                </footer>
              </blockquote>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- TYPOGRAPHY -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Abbreviations
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <h6 class="card-subtitle">
                Use text utilities as needed to change the alignment of your
                blockquote.
              </h6>
              <blockquote class="blockquote">
                <p class="mb-0">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Integer posuere erat a ante.
                </p>
                <footer class="blockquote-footer">
                  Someone famous in
                  <cite title="Source Title">Source Title</cite>
                </footer>
              </blockquote>
              <blockquote class="blockquote text-center">
                <p class="mb-0">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Integer posuere erat a ante.
                </p>
                <footer class="blockquote-footer">
                  Someone famous in
                  <cite title="Source Title">Source Title</cite>
                </footer>
              </blockquote>
              <blockquote class="blockquote text-right">
                <p class="mb-0">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Integer posuere erat a ante.
                </p>
                <footer class="blockquote-footer">
                  Someone famous in
                  <cite title="Source Title">Source Title</cite>
                </footer>
              </blockquote>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- TYPOGRAPHY -->
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
  components: {
    BaseCard,
    BaseHeader
  }
};
</script>

<!--====  End of TYPOGRAPHY  ====-->
